export default __webpack_public_path__ + "static/media/gmail.9f8b811a.svg";